// @ts-check

import jQuery from 'jquery';
import '../slick.min.js';

import { nextArrow, prevArrow } from "../parts/slick-defaults.js";

jQuery( function( $ ) {
    const galleries = document.querySelectorAll( '.media-and-content__gallery' );

    galleries.forEach( gallery => {
        $( gallery ).slick( {
            nextArrow,
            prevArrow
        } );
    } );
} );